// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonRow = "ButtonRow__buttonRow__Ie229";
export const buttonWrapper = "ButtonRow__buttonWrapper__JxoY1";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const singleButtonRow = "ButtonRow__singleButtonRow__JHdt6";